<template>
  <v-col>
    <!-- Suppliers data table -->
    <supplier-table
      :key="index"
      url-api="/supplier"
      :headers="headers"
    >
      <!-- Add Supplier -->
      <template v-slot:urlCreate="">
        <v-btn
          class="info"
          @click.prevent="
            $router.push({
              name: 'AddNewSupplier',
            })
          "
        >
          <v-icon>mdi-plus</v-icon>
          Add Supplier
        </v-btn>
      </template>

      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- Supplier details -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'SupplierDetail',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-more
              </v-icon>
            </v-btn>
          </template>
          <span>More details</span>
        </v-tooltip>
        <!-- end -->

        <!-- Supplier info edit -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'EditSupplier',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <!-- end -->

        <!-- Supplier remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="warningSupplierRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </supplier-table>

    <!-- end data table -->

    <!-- Supplier remove confirmation dialog  -->
    <v-dialog
      v-model="supplierRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline red--text">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove supplier?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="supplierRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeSupplier"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import SuppliersTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "supplier-table": SuppliersTable,
  },
  data() {
    return {
      supplierRemoveWarning: false,
      supplier: [],
      index: 1,
      headers: [
        {
          text: "Created At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Name",
          sortable: true,
          value: "firstName",
        },
        {
          text: "Email",
          sortable: false,
          value: "email",
        },
        {
          text: "Phone",
          sortable: false,
          value: "phone",
        },
        {
          text: "Company",
          sortable: false,
          value: "company",
        },
        {
          text: "Address",
          sortable: false,
          value: "address",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    removeSupplier() {
      window.axios
        .delete("/supplier/" + this.$data.supplier.id)
        .then((response) => {
          this.$data.supplierRemoveWarning = false;
          this.feedback(response.data.message);
          this.$data.index++;
        });
    },
    warningSupplierRemove(supplier) {
      this.$data.supplier = supplier;
      this.$data.supplierRemoveWarning = true;
    },
  },
};
</script>
